import { getOrCreatePulse } from '@tools/tracking/utils';

const trackModalView = (): void => {
  getOrCreatePulse()?.queueEvent({
    object: {
      '@id':
        'sdrn:subito:content:premiumsearch:element:premiumsearch_awareness',
      '@type': 'UIElement',
    },
    '@type': 'View',
  });
};

const trackModalInterest = (): void => {
  getOrCreatePulse()?.queueEvent({
    action: 'Click',
    object: {
      elementType: 'Button',
      '@id': 'sdrn:subito:page:listing:element:premiumsearch_interest',
      '@type': 'UIElement',
    },
    '@type': 'Click',
  });
};

const trackModalDismiss = (): void => {
  getOrCreatePulse()?.queueEvent({
    action: 'Click',
    object: {
      '@id': 'sdrn:subito:page:listing:element:premiumsearch_dismiss',
      '@type': 'UIElement',
    },
    '@type': 'Click',
  });
};

export { trackModalView, trackModalInterest, trackModalDismiss };
